import React, { useEffect, useState } from 'react'
import { GetProductsBySerialByArtNo } from '../../../Services/ProductService'
import { useConfig } from '../../../Providers/ConfigProvider'
import { useAuth } from '../../../Providers/AuthProvider'

const useGetProductsBySerial = (product) => {
    const { api } = useConfig()
    const { authState } = useAuth()
    const [productsWithSameSerial, setProductsWithSameSerial] = useState(null)
    const [isProductsWithSameSerialLoading, setIsProductsWithSameSerialLoading] = useState(false)

    useEffect(() => {
        if (product)
            setIsProductsWithSameSerialLoading(true)
        GetProductsBySerialByArtNo(api, product.index, authState.custId, authState.siteId, authState.whId)
            .then(res => {
                setProductsWithSameSerial(res.data)
                setIsProductsWithSameSerialLoading(false)
            })
            .catch(e => console.log(e))
    }, [product])

    return { productsWithSameSerial, isProductsWithSameSerialLoading }

}

export default useGetProductsBySerial